export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-hacker-news-9a768c304987809540f73c97a6ba91d9.svg";